import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../fonts.css";
import { useTranslation } from "react-i18next";

const ProductSelection = () => {
  const [hoveredId, setHoveredId] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );
  const navigate = useNavigate();
  const { t } = useTranslation();


  // 添加窗口大小监听
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 检查是否为移动设备
  const isMobile = windowWidth <= 767;

  const products = [
    {
      id: 1,
      name: "PTag",
      subTitle: t('product1_subtitle'),
      isAir: false,
      image: "/product/metal-2.png",
    },
    {
      id: 2,
      name: "PTag Air",
      subTitle: t('product2_subtitle'),
      isAir: true,
      image: "/product/plastic-2.png",
    },
  ];

  // 基础样式
  const styles = {
    section: {
      width: "100%",
      padding: "60px 20px",
      textAlign: "center",
      backgroundColor: "#ffffff",
    },
    heading: {
      fontFamily: "Helvetica",
      fontSize: isMobile ? "26px" : "44px",
      fontWeight: "bold",
      marginBottom: "30px",
      color: "#000",
    },
    button: {
      fontFamily: "Helvetica",
      backgroundColor: "#FFB60C",
      color: "#000",
      border: "none",
      padding: "10px 20px",
      borderRadius: "3px",
      fontSize: isMobile ? "15px" : "16px",
      fontWeight: "bold",
      cursor: "pointer",
      marginBottom: "40px",
      transition: "background-color 0.3s",
    },
    productContainer: {
      display: "flex",
      justifyContent: "center",
      gap: isMobile ? "20px" : "20%", // 移动端减少间距
      flexWrap: "nowrap",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    productCard: (isHovered) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: isMobile ? "48%" : "250px", // 移动端减小宽度
      transition: "transform 0.3s ease",
      transform: isHovered ? "translateY(-5px)" : "translateY(0)",
      cursor: "pointer",
    }),
    imageContainer1: (isHovered) => ({
      width: isMobile ? "150px" : "300px", // 移动端使用更小的尺寸
      height: isMobile ? "150px" : "300px", // 同上
      marginBottom: isMobile ? "15px" : "25px", // 减少移动端的底部边距
      aspectRatio: "1 / 1",
      borderRadius: "50%",
      overflow: "hidden",
      transition: "all 0.3s ease",
      transform: isHovered ? "scale(1.05)" : "scale(1)",
    }),
    imageContainer2: (isHovered) => ({
      width: isMobile ? "200px" : "400px", // 移动端使用更小的尺寸
      height: isMobile ? "150px" : "300px", // 同上
      marginBottom: isMobile ? "15px" : "25px", // 减少移动端的底部边距
      aspectRatio: "1 / 1",
      borderRadius: "50%",
      overflow: "hidden",
      transition: "all 0.3s ease",
      transform: isHovered ? "scale(1.05)" : "scale(1)",
    }),
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    title: {
      fontFamily: "Helvetica",
      fontSize: isMobile ? "20px" : "34px", // 移动端使用固定更小的字体
      fontWeight: "bold",
      marginBottom: "8px",
      color: "#000",
    },
    subtitle: {
      fontFamily: "Helvetica",
      fontSize: isMobile ? "16px" : "21px", // 移动端使用固定更小的字体
      color: "#050505",
      fontWeight: "400",
      marginTop: "0",
    },
    highlight: {
      color: "#65A8FB",
    },
  };

  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>{t('ProductSelection_title')}</h2>

      <div style={styles.productContainer}>
        {products.map((product) => (
          <div
            key={product.id}
            style={styles.productCard(hoveredId === product.id)}
            onMouseOver={() => setHoveredId(product.id)}
            onMouseOut={() => setHoveredId(null)}
            onClick={
              product.id === 1
                ? () => navigate("/ptag")
                : product.id === 2
                  ? () => navigate("/ptag-air")
                  : undefined
            }
          >
            {product.id === 1 &&
              <div style={styles.imageContainer1(hoveredId === product.id)}>
                <img
                  src={product.image}
                  alt={`${product.name} 图片`}
                  style={styles.image}
                />
              </div>}
            {product.id === 2 &&
              <div style={styles.imageContainer2(hoveredId === product.id)}>
                <img
                  src={product.image}
                  alt={`${product.name} 图片`}
                  style={styles.image}
                />
              </div>}


            <h3 style={styles.title}>
              {product.isAir ? (
                <>
                  PTag <span style={styles.highlight}>Air</span>
                </>
              ) : (
                product.name
              )}
            </h3>
            <p style={styles.subtitle}>{product.subTitle}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductSelection;
